import styled from 'styled-components';

export const Message = styled.div`
  display: none;
  width: 215px;
  background: var(--white);
  padding: 8px 13px 10px 13px;
  position: absolute;
  left: -9px;
  top: 36px;
  z-index: 1;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 8px;

  @media (min-width: 768px) {
    display: none !important;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Trian = styled.div`
  top: -7px;
  z-index: 111;
  width: 11px;
  padding-bottom: 3.5%;
  overflow: hidden;
  position: absolute;
  left: 16px;
  right: auto;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    transform-origin: 0 100%;
    transform: rotate(45deg);
  }
`;

export const Content = styled.div``;

export const Title = styled.h3`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5em;
  color: var(--naval100);
  margin-bottom: 0;

  &:not(:last-child) {
    margin-bottom: inherit;
  }
`;

export const Paragraph = styled.p`
  font-size: 12px;
  line-height: 1.25em;
  color: var(--naval100);
  margin-bottom: 0;
`;
